import { axiosInstance } from "../axios-Instance";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../react-query/constants";
import { getLoginToken } from "../storage";

async function getAnnouncement() {
  const data = await axiosInstance({
    url: "/announcement",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

const createAnnouncement = async (formData: any) => {
  const data = await axiosInstance({
    url: "/announcement",
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const updateAnnouncement = async (formData: any) => {
  const data = await axiosInstance({
    url: `/announcement/${formData["_id"]}`,
    method: "PUT",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const deleteAnnouncement = async (formData: any) => {
  const data = await axiosInstance({
    url: `/announcement/${formData}?hard=true`,
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

export function useAnnouncement() {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.announcement],
    queryFn: () => getAnnouncement(),
  });
  return data;
}

export function useCreateAnnouncement() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => createAnnouncement(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.announcement]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useUpdateAnnouncement() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => updateAnnouncement(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.announcement]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useDeleteAnnouncement() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => deleteAnnouncement(formData),
    onSuccess: (data) => {
      //   toast.success("Announcement Deleted Successfully", toastOptions);
      queryClient.invalidateQueries([queryKeys.announcement]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}
